<template>
  <div>
    <b-card no-body class="border-top mx-1 py-1 my-0">
      <b-row>
        <b-col>
          <div>
            <h4>
              <b-icon icon="stars" />
              AI Generated
            </h4>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="!hasData">
        <b-col>
          <div class="text-center my-2">
            <b-spinner small type="grow" label="Loading..." />
          </div>
        </b-col>
      </b-row>
      <b-row v-else>
        <b-col>
          <div>
            <h5>Explanation:</h5>
            <p>
              {{ aiResponse.explanation || "No explanation provided." }}
            </p>
          </div>
        </b-col>
      </b-row>
      <b-row v-if="hasData && aiResponse.suggestions && aiResponse.suggestions.length">
        <b-col>
          <div>
            <h5>Suggestions:</h5>
            <ul class="mt-1">
               <li v-for="(item, index) in aiResponse.suggestions" :key="index" class="ml-n2">
                {{ item }}
              </li>
            </ul>
          </div>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
export default {
  props: {
    alertAggkey: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      aiResponse: {},
      loaded: false,
    };
  },
  computed: {
    alertSuggestionsUrl() {
      return `/alerts/${this.alertAggkey}/suggestions.json`;
    },
    hasData() {
      return this.loaded;
    },
  },
  mounted() {
    this.httpGet();
  },
  methods: {
    httpGet() {
      this.$http
        .get(this.alertSuggestionsUrl, {
          params: {},
        })
        .catch(() => {
          this.aiResponse = {};
        })
        .then((response) => { this.aiResponse = response.data; })
        .finally(() => {
          this.loaded = true;
        });
    },
  },
};
</script>
